import { Route } from '@angular/router';
import { PermissionGuard } from '@shared-services/permission';

export const collectionRoute: Route = {
  path: 'collection',
  data: { title: 'Collection' },
  canActivate: [PermissionGuard],
  loadChildren: () => import('./../modules/collection/collection.module').then(m => m.CollectionModule)
};
